(() => {
  const cart = document.querySelector('.ofauria-cart-test cart-form');
  if (!cart) return;
  const status = cart.querySelector('.ofauria-cart-status');
  if (!status) return;
  let timeout;
  let refreshing = false;
  const begin = () => {
    clearTimeout(timeout);
    status.textContent = status.dataset.updating;
    timeout = setTimeout(() => { status.textContent = status.dataset.retry; }, 12000);
  };
  cart.addEventListener('click', (event) => {
    if (event.target.closest('.cart-item__remove, .quantity-down, .quantity-up')) begin();
  });
  cart.addEventListener('change', (event) => {
    if (event.target.matches('.cart-item__quantity-input')) begin();
  });
  new MutationObserver(() => {
    if (cart.classList.contains('cart-form--refreshing')) {
      refreshing = true;
    } else if (refreshing) {
      refreshing = false;
      clearTimeout(timeout);
      status.textContent = status.dataset.updated;
    }
  }).observe(cart, { attributes: true, attributeFilter: ['class'] });
})();
